import { lazy } from "react";
import { MODULE_IDS } from "../../../../../../constants/enums";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";


const HabitationalG4Sign = Loadable(
  lazy(() =>
    import(
      "./HabitationalG4Sign"
    ).then(({ HabitationalG4Sign }) => ({
      default: HabitationalG4Sign,
    }))
  )
);

const HabitationalG4SignManageDocument = Loadable(
  lazy(() =>
    import(
      "./HabitationalG4SignManageDocument"
    ).then(({ HabitationalG4SignManageDocument }) => ({
      default: HabitationalG4SignManageDocument,
    }))
  )
);



export const HabitationalG4SignRouter = [
       {
            path: "/habitational-policy/:customerId/g4-sign/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
               <HabitationalG4Sign/>
              </AuthorizedRoute>
            ),
          },
           {
            path: "/habitational-policy/:customerId/g4-sign/:customerPolicyId/manage",
            exact: true,
            element: ( 
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
               <HabitationalG4SignManageDocument/>
              </AuthorizedRoute>
            ),
          },
           {
            path: "/habitational-policy/:customerId/g4-sign/:customerPolicyId/manage/:documentCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                 <HabitationalG4SignManageDocument/>
              </AuthorizedRoute>
            ),
          },

]